import React, { Fragment } from 'react'
import { Box } from '@chakra-ui/react'
import { useAccount } from '@lib/context/account-context'
import { OTP_DISABLED } from '@constants/auth.constant'

interface PropsType {
  isLogin?: boolean
  children: React.ReactNode
  filter?: boolean
}

const AuthFilter = ({
  isLogin,
  children,
  filter,
  ...rest
}: PropsType & any) => {
  const { customer } = useAccount()

  return (
    <Fragment {...rest}>
      {filter ? (
        <Fragment>
          {isLogin && customer && children}
          {!isLogin && !customer && children}
        </Fragment>
      ) : (
        <Fragment>
          {/* TEMP (OTP disabled): new accounts never get is_verify_otp=true while OTP is
              off, which hid the profile icon (/account). Only require a logged-in customer.
              Remove `OTP_DISABLED ||` to restore. */}
          {customer &&
            (OTP_DISABLED || (customer as any).is_verify_otp === true) &&
            children}
        </Fragment>
      )}
    </Fragment>
  )
}

export default AuthFilter
